import { useContext } from "react";
import { NameContext } from "../../context/NameContext";

// Benutzerdefinierter Hook, um den Namen aus dem Kontext zu holen
export const useInsertName = () => {
  const { name } = useContext(NameContext);

  // Gibt den Namen direkt zurück (Name sollte immer vorhanden sein)
  return name || "Neugierig"; // "Gast" ist der Fallback-Wert
};